import { styled } from "@tamagui/core";
import { getButtonSized } from "@tamagui/get-button-sized";
import { XStack } from "./Stacks";
import {
  bordered,
  circular,
  elevate,
  focusTheme,
  hoverTheme,
  pressTheme
} from "./variants";
const SizableStack = styled(XStack, {
  name: "SizableStack",
  variants: {
    unstyled: {
      true: {
        hoverTheme: false,
        pressTheme: false,
        focusTheme: false,
        elevate: false,
        bordered: false
      },
      false: {
        backgroundColor: "$background",
        flexShrink: 1
      }
    },
    hoverTheme,
    pressTheme,
    focusTheme,
    circular,
    elevate,
    bordered,
    size: {
      "...size": getButtonSized
    }
  }
});
export {
  SizableStack
};
//# sourceMappingURL=SizableStack.js.map
